<template>
  <router-view />
</template>
<script>
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style name="mainPage" lang="less">
@themeColor: #0dc98e;
@hoverColor: #65DDB8;
body {
  margin: 0;
}
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
.table-icon {
  padding-left: 6px;
  padding-right: 6px;
  color: #0dc98e;
  font-size: 20px;
  cursor: pointer;
}
.table-icon:hover {
  color: #65DDB8;
}
.table-icon.table-icon-disabled {
  color: #969696;
  cursor: not-allowed;
}
.table-icon.table-icon-disabled:hover {
  color: #969696;
}
.product_tab_1 .pulldownbox {
  background-color: #f4f4f4;
  padding-left: 10px;
  color: gray;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
}
.product_tab_1 .count_content {
  font-size: 14px;
  font-weight: bold;
  color: gray;
  height: auto;
  line-height: 46px;
  padding-left: 10px;
  width: 100%;
}

.el-dialog__body .inform_title {
  font-size: 14px;
  color: rgb(34, 34, 34);
  // height: 46px;
  line-height: 2;
  padding-left: 10px;
  width: 100%;
}
.el-dialog__body .inform_title .title_name {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  border-left: 4px solid @themeColor;
  padding-left: 8px;
  font-size: 16px;
  font-weight: bold;
  color: #0dc98e;
}
.product_tab_1 .count_content .icon-table-summary {
  color: #67c23a;
  font-size: 16px;
}
.pulldownbox .el-icon-info {
  color: #909399;
  font-size: 16px;
}
</style>

/*_弹出大log的表头样式*/
<style lang="less">
.el-dialog__header {
  padding: 20px 20px 10px;
  background: #f6f7f9;
}
.el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  display: block;
  height: 20px;
}
.el-dialog__header {
  text-align: left !important;
  padding: 12px 20px 10px !important;
  font-size: 16px !important;
  .el-dialog__title {
    color: #333333;
  }
  .el-dialog__headerbtn {
    top: 16px !important;
    .el-dialog__close {
      color: #333333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue